export default {
  LOAD_EVENT_SESSION_LIST_START: 'LoadGeneralCompetencyEventSessionListStart',
  LOAD_EVENT_SESSION_LIST_END: 'LoadGeneralCompetencyEventSessionListEnd',
  TOGGLE_EVENT_SESSION_LIST_CONFIRM_DIALOG: 'ToggleGeneralCompetencyEventSessionListConfirmDialog',
  SET_CONFIRM_DIALOG_ERROR: 'SetGeneralCompetencyEventSessionListConfirmDialogError'
};
